import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { motion } from 'framer-motion';

export const YouTubeVideo = ({ videoId, title = "Video", thumbnail = null }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const getThumbnailUrl = (id) => {
    return `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
  };

  return (
    <div className="w-full h-full relative overflow-hidden rounded-2xl">
      {/* Background with thumbnail */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${thumbnail || getThumbnailUrl(videoId)})` }}
      >
        {/* Subtle overlay - keep it minimal */}
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      <div className="absolute inset-0 group cursor-pointer" onClick={() => setIsLoaded(true)}>
        {/* Play Button Section */}
        {!isLoaded && (
          <motion.div
            className="absolute inset-0 flex items-center justify-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative z-10">
              {/* Play Button */}
              <motion.div
                className="w-24 h-24 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-2xl shadow-emerald-500/60"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: 'spring', stiffness: 400, damping: 17 }}
              >
                <motion.div
                  animate={{ x: [0, 2, 0] }}
                  transition={{ duration: 2, repeat: Infinity }}
                >
                  <Play className="w-10 h-10 text-white fill-white ml-1" />
                </motion.div>
              </motion.div>

              {/* Title below button */}
              <motion.div
                className="absolute top-32 left-1/2 -translate-x-1/2 text-center w-64"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                <p className="text-white font-bold text-xl drop-shadow-lg">{title}</p>
                <p className="text-emerald-300 text-sm mt-2">Cliquez pour regarder</p>
              </motion.div>
            </div>
          </motion.div>
        )}

        {/* YouTube Iframe */}
        {isLoaded && (
          <motion.div
            className="w-full h-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full rounded-2xl"
            />
          </motion.div>
        )}
      </div>

      {/* Simple border */}
      <div className="absolute inset-0 rounded-2xl pointer-events-none border border-emerald-500/30" />
    </div>
  );
};
